import {getReportResult, getInvoiceBillData} from "@/api/api";

function initialState() {
  return {
    //测评报告信息
    resultData: {
      riskWordCloudList:[{"id":120358,"titleName":"商品采购地区分析","riskLevel":1},{"id":120359,"titleName":"商品销售地区分析","riskLevel":1},{"id":120363,"titleName":"顶额开票风险分析","riskLevel":1},{"id":120365,"titleName":"客户公司相关的法律诉讼风险","riskLevel":1},{"id":120366,"titleName":"开票月份风险点","riskLevel":1},{"id":120367,"titleName":"向社保人数为0的单位开具销售发票","riskLevel":1},{"id":120372,"titleName":"供应商公司相关的法律诉讼风险","riskLevel":1},{"id":120373,"titleName":"公司名称与税号匹配分析","riskLevel":1},{"id":120374,"titleName":"从社保人数为0的单位取得发票","riskLevel":1},{"id":120389,"titleName":"应收账款与收入变动差异较大，存在未按规定确认收入的风险","riskLevel":1},{"id":120391,"titleName":"应收账款新增金额过大，存在少计收入的风险","riskLevel":1},{"id":120393,"titleName":"期末存货余额占销售收入比异常增长预警","riskLevel":1},{"id":120364,"titleName":"作废发票风险检测","riskLevel":2},{"id":120369,"titleName":"收到代开发票风险分析","riskLevel":2},{"id":120370,"titleName":"取得税额为零的发票风险","riskLevel":2},{"id":120371,"titleName":"取得红字发票风险分析","riskLevel":2},{"id":120375,"titleName":"取得个人独资企业、个体工商户发票分析","riskLevel":2},{"id":120376,"titleName":"取得“餐饮费”发票风险","riskLevel":2},{"id":120377,"titleName":"取得“经纪代理服务”发票风险","riskLevel":2},{"id":120388,"titleName":"存货余额过大，可能存在滞后确认收入的风险","riskLevel":2},{"id":120390,"titleName":"流动资产增长率远高于收入增长率，存在隐瞒收入的风险","riskLevel":2},{"id":120392,"titleName":"存货余额占总资产比例过大，可能存在滞后确认收入的风险","riskLevel":2},{"id":120398,"titleName":"增值税税负变动率与主营业务毛利变动率之比异常预警","riskLevel":2},{"id":120395,"titleName":"未处理增值税收入与营业收入的税会差异，存在少报应税收入的风险","riskLevel":3},{"id":120397,"titleName":"资产负债表与利润表不勾稽","riskLevel":3}]
    },
    resultHeadLegends: {},//可视化报告的图表的legend
  };
}

export const state = {
  ...initialState()
};
import {cloneDeep} from "lodash";

export const mutations = {
  initResultHeadLegends(state, {groupName, size}) {
    const resultHeadLegends = cloneDeep(state.resultHeadLegends)
    if (!resultHeadLegends[groupName]) {
      resultHeadLegends[groupName] = []

      for (let i = 0; i < size; i++) {
        resultHeadLegends[groupName][i] = true
      }

    }
    state.resultHeadLegends = resultHeadLegends;
  },
  toggleResultHeadLegends(state, {groupName, index}) {
    const resultHeadLegends = cloneDeep(state.resultHeadLegends)
    resultHeadLegends[groupName][index] = !resultHeadLegends[groupName][index];
    state.resultHeadLegends = resultHeadLegends;
  },
  setResultHeadLegends(state, {groupName, index, value}) {
    const resultHeadLegends = cloneDeep(state.resultHeadLegends)
    resultHeadLegends[groupName][index] = value;
    state.resultHeadLegends = resultHeadLegends;
  },
  showOnlyResultHeadLegends(state, {groupName, index}) {
    const resultHeadLegends = cloneDeep(state.resultHeadLegends)
    for (const i in resultHeadLegends[groupName]) {
      resultHeadLegends[groupName][i] = false
    }
    resultHeadLegends[groupName][index] = true;
    state.resultHeadLegends = resultHeadLegends;
  },

  setShowResultMask(state, isShow) {
    state.showResultMask = isShow;
  },
  setResultData(state, resultData) {
    state.resultData = resultData;
  },
  setIsFromUpload(state, isFromUpload) {
    state.isFromUpload = isFromUpload;
  },
  setInvoice(state, data) {
    state.invoice = data;
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },

  // 优惠政策、排序、点赞
  setPolicy(state, resultData) {
    state.resultPolicy = resultData;
  },
  sortSt(state, index) {
    let item = state.resultPolicy;
    if (index < 90) {
      if (item[index.substring(0, 1)].btnActive == index.slice(-1)) {
        item[index.substring(0, 1)].btnActive = 2;
        item.sort((a, b) => {
          return b.btnActive - a.btnActive;
        });
        return;
      }
      item[index.substring(0, 1)].btnActive = index.slice(-1);
      item.sort((a, b) => {
        return b.btnActive - a.btnActive;
      });
    } else {
      if (item[index.substring(0, 2)].btnActive == index.slice(-1)) {
        item[index.substring(0, 2)].btnActive = 2;
        item.sort((a, b) => {
          return b.btnActive - a.btnActive;
        });
        return;
      }
      item[index.substring(0, 2)].btnActive = index.slice(-1);
      item.sort((a, b) => {
        return b.btnActive - a.btnActive;
      });
    }
  }
};

/**
 * 载入公司认证信息
 * 调用方法:
 * 多次调用只调用一次:await this.$store.cache.dispatch("loadCompanyRenzheng");
 * 删除调用的缓存,使上面的方法可以再次调用 this.$store.cache.delete('loadCompanyRenzheng');
 * 普通调用(多次调用调用多次): await this.$store.dispatch("loadCompanyRenzheng");
 */

export const actions = {
  //载入测评报告信息
  async loadResultData({commit, rootState}, {uuid, bankId, nsrsbh, zq}) {
    const token = rootState.authorization;
    let data;
    try {
      data = await getReportResult(uuid, token, bankId, nsrsbh, zq);
    } catch (error) {
      throw error;
    }

    if (data.msgCode == 1) {
      commit("setResultData", data.data);
    } else {
      // eslint-disable-next-line no-console
      console.error(data);
    }

    // 优惠政策有缓存取缓存
    if (JSON.parse(localStorage.getItem("policy"))) {
      // 取缓存
      commit("setPolicy", JSON.parse(localStorage.getItem("policy")));
    } else {
      // 模拟按钮状态以及点赞总数
      data.data.policyAreaList.forEach(item => {
        item.btnActive = 2;
        item.number = 100;
        item.isTrue = 0;
      });
      commit("setPolicy", data.data.policyAreaList);
    }
  },

  //载入测评发票文本与数据
  async loadInvoice({commit, rootState}, {uuid, bankId, nsrsbh, zq}) {
    try {
      const res = await getInvoiceBillData({nsrsbh, uuid, zq, bankId});
      if (res.msgCode == "1") {
        // this.InvoiceData = res.data.InvoiceData;
        // this.InvoiceText = res.data.InvoiceText;
        commit("setInvoice", res.data);
      } else {
        commit("setInvoice", {
          InvoiceText: {},
          InvoiceData: {}
        });
      }
    } catch (error) {
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
